<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-usuarios',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowUsuario',
      'isShowCompleteName',
      'isShowFechaAlta',
      'isShowNumeroIntentos',
      'isShowActivo',
      'isShowEmail',
      'isShowFechaUltimaConexion',
      'isShowNumeroIdentificacion'
    ])
  },
  methods: {
    ...mapActions([
      'isShowUsuarioAction',
      'isShowCompleteNameAction',
      'isShowFechaAltaAction',
      'isShowNumeroIntentosAction',
      'isShowActivoAction',
      'isShowEmailAction',
      'isShowFechaUltimaConexionAction',
      'isShowNumeroIdentificacionAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'nombre_usuario':
          isShow = !this.isShowUsuario
          this.isShowUsuarioAction(isShow)
          break
        case 'nombre_completo':
          isShow = !this.isShowCompleteName
          this.isShowCompleteNameAction(isShow)
          break
        case 'fecha_alta':
          isShow = !this.isShowFechaAlta
          this.isShowFechaAltaAction(isShow)
          break
        case 'intentos':
          isShow = !this.isShowNumeroIntentos
          this.isShowNumeroIntentosAction(isShow)
          break
        case 'fecha_ultima_conexion':
          isShow = !this.isShowFechaUltimaConexion
          this.isShowFechaUltimaConexionAction(isShow)
          break
        case 'numero_identificacion':
          isShow = !this.isShowNumeroIdentificacion
          this.isShowNumeroIdentificacionAction(isShow)
          break
        case 'activo':
          isShow = !this.isShowActivo
          this.isShowActivoAction(isShow)
          break
        case 'email':
          isShow = !this.isShowEmail
          this.isShowEmailAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('users.users_entity_table.username'), value: 'nombre_usuario', show: this.isShowUsuario
        }, {
          text: this.$t('users.users_entity_table.complete_name'), value: 'nombre_completo', show: this.isShowCompleteName
        }, {
          text: this.$t('users.users_entity_table.creation_datetime'), value: 'fecha_alta', show: this.isShowFechaAlta
        }, {
          text: this.$t('users.users_entity_table.trail'), value: 'intentos', show: this.isShowNumeroIntentos
        }, {
          text: this.$t('users.users_entity_table.last_connection_date'), value: 'fecha_ultima_conexion', show: this.isShowFechaUltimaConexion
        }, {
          text: this.$t('users.users_entity_table.enable'), value: 'activo', show: this.isShowActivo
        }, {
          text: this.$t('users.users_entity_table.email'), value: 'email', show: this.isShowEmail
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
 .ods-dropdown {
    display: flex;
}
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
